const state = {
  inboxes: null,
  inbox: null
}

const getters = {
  inboxes: state => state.inboxes,
  inbox: state => state.inbox
}

const mutations = {
  SET_INBOXES (state, inboxes) {
    state.inboxes = inboxes
  },
  SET_INBOX (state, inbox) {
    state.inbox = inbox
  }
}

export default {
  state,
  getters,
  mutations
}
